class CouponPopup extends HTMLElement {
  constructor() {
    super();
    this.code = this.dataset.code;
    this.delay = parseInt(this.dataset.delay, 10) || 4;

    this.overlayEl = this.querySelector('[data-coupon-popup-overlay]');
    this.closeEl = this.querySelector('[data-coupon-popup-close]');
    this.dialogEl = this.querySelector('.coupon-popup__dialog');
    this.formStepEl = this.querySelector('[data-coupon-popup-step="form"]');
    this.successStepEl = this.querySelector('[data-coupon-popup-step="success"]');
    this.codeEl = this.querySelector('[data-coupon-popup-code]');
    this.form = this.querySelector('#CouponPopupForm');

    this.closeEl.addEventListener('click', () => this.dismiss());
    this.overlayEl.addEventListener('click', () => this.dismiss());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) this.dismiss();
    });

    this.init();
  }

  init() {
    // Server-authoritative: these markers are rendered by Liquid based on the
    // actual customer-form result, so we never show a code on a rejected submit.
    const postedSuccess = this.querySelector('[data-coupon-popup-posted="success"]');
    const hasError = this.querySelector('.coupon-popup__error');

    if (postedSuccess) {
      window.localStorage.setItem('rugCouponSubscribed', 'true');
      this.showSuccess();
      this.open();
      return;
    }

    if (hasError) {
      // Signup was rejected (invalid/blocked email): reopen with the form + error
      // visible. Do NOT mark subscribed or suppress the popup.
      this.open();
      return;
    }

    const subscribed = window.localStorage.getItem('rugCouponSubscribed');
    const dismissed = window.localStorage.getItem('rugCouponDismissed');
    if (subscribed || dismissed) return;

    window.setTimeout(() => this.open(), this.delay * 1000);
  }

  open() {
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    if (typeof trapFocus === 'function' && this.dialogEl) trapFocus(this.dialogEl);
  }

  dismiss() {
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    if (!window.localStorage.getItem('rugCouponSubscribed')) {
      window.localStorage.setItem('rugCouponDismissed', 'true');
    }
  }

  showSuccess() {
    this.formStepEl.hidden = true;
    this.successStepEl.hidden = false;
    if (this.codeEl) this.codeEl.textContent = this.code;
  }
}

customElements.define('coupon-popup', CouponPopup);
